import { MainContentArea, ContentHeader } from "melco-ui";
import { ProductsList } from "../../components/products/ProductsList";
import { useTranslation } from "react-i18next";
import { useRolesContext } from "../../hooks/roles/useRolesContext";

// To Do: Add BreadCrum
// Add Translation
export const Products: React.FC = () => {
  const { t } = useTranslation();
  //const breadcrumb = useBreadcrumb("orders");
  const {roles } = useRolesContext();
  

  return (
    <MainContentArea
      header={
        <ContentHeader 
          title={t("main_menu.products")}
          
        />
        
      }
    >
    
       {roles.SYSTEM_PRODUCTS_VIEW && <ProductsList />} 
    </MainContentArea>
  );
};
